export const SWYCHR_MARKETS = [
  { countryCode: 'CM', currency: 'XAF', dial: '+237', flag: '🇨🇲', label: 'Cameroon' },
  { countryCode: 'KE', currency: 'KES', dial: '+254', flag: '🇰🇪', label: 'Kenya' },
  { countryCode: 'GA', currency: 'XAF', dial: '+241', flag: '🇬🇦', label: 'Gabon' },
  { countryCode: 'CD', currency: 'CDF', dial: '+243', flag: '🇨🇩', label: 'Congo DRC' },
  { countryCode: 'SN', currency: 'XOF', dial: '+221', flag: '🇸🇳', label: 'Senegal' },
  { countryCode: 'CI', currency: 'XOF', dial: '+225', flag: '🇨🇮', label: "Cote D'Ivoire" },
  { countryCode: 'BF', currency: 'XOF', dial: '+226', flag: '🇧🇫', label: 'Burkina Faso' },
  { countryCode: 'ML', currency: 'XOF', dial: '+223', flag: '🇲🇱', label: 'Mali' },
  { countryCode: 'BJ', currency: 'XOF', dial: '+229', flag: '🇧🇯', label: 'Benin' },
  { countryCode: 'TG', currency: 'XOF', dial: '+228', flag: '🇹🇬', label: 'Togo' },
  { countryCode: 'TZ', currency: 'TZS', dial: '+255', flag: '🇹🇿', label: 'Tanzania' },
  { countryCode: 'UG', currency: 'UGX', dial: '+256', flag: '🇺🇬', label: 'Uganda' },
  { countryCode: 'NG', currency: 'NGN', dial: '+234', flag: '🇳🇬', label: 'Nigeria' },
  { countryCode: 'NE', currency: 'XOF', dial: '+227', flag: '🇳🇪', label: 'Niger' },
  { countryCode: 'RW', currency: 'RWF', dial: '+250', flag: '🇷🇼', label: 'Rwanda' },
  { countryCode: 'CG', currency: 'XAF', dial: '+242', flag: '🇨🇬', label: 'Congo Brazzaville' },
  { countryCode: 'GN', currency: 'GNF', dial: '+224', flag: '🇬🇳', label: 'Guinea Conakry' },
  { countryCode: 'GH', currency: 'GHS', dial: '+233', flag: '🇬🇭', label: 'Ghana' },
];

export function getSwychrMarketByCountry(countryCode) {
  const normalized = String(countryCode || '').trim().toUpperCase();
  return SWYCHR_MARKETS.find((market) => market.countryCode === normalized) || null;
}
